// removed by extract-text-webpack-plugin
module.exports = {"binary_accordion_section":"_3INVedBLeSUPK3yvcJHk80","body":"_3RrLHqr5qdNmAVTUKhiV9K","selected":"LuvXHi4Gvww4g55RXP7AL"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryAccordion/BinaryAccordion.scss
// module id = 2183
// module chunks = 1